import React, { useState } from 'react';
import './FileInboxSelector.scss';
import { NoOp } from '../../helpers/Utils';
import languageManager from '../../helpers/Language';
import { InboxFolderList } from '../../helpers/InboxFolder';
import UserAnalytic from '../../helpers/UserAnalytic';

export const Item = ({
    name, imgSrc, active,
    onClick
}) => {
    return (
        <div
            className={'fis-item ' + (active ? 'active' : '')}
            onClick={onClick}
        >
            <img src={imgSrc} className="fis-item-img" />
            <span className="fis-item-label">{name}</span>
        </div>
    );
};

const FileInboxSelector = ({
    className = '',
    defaultInbox = 0,
    onInboxSelected = NoOp
}) => {
    const [selectedElement, setSelectedElement] = useState(defaultInbox);
    const handleSelectElement = (idx) => {
        setSelectedElement(idx);
        UserAnalytic.event({
            category: 'File Selector',
            action: 'Select file',
        });
        const elm = InboxFolderList[idx];
        onInboxSelected(elm);
    };
    return (
        <div className={"file-inbox-selector " + className}>
            {InboxFolderList.map((item, idx) => (
                item.status ? 
                    <Item
                        key={idx}
                        name={languageManager.T(item.name)}
                        imgSrc={item.imgSrc}
                        onClick={() => handleSelectElement(idx)}
                        active={idx === selectedElement}
                    /> : null
            ))}
        </div>
    );
};

FileInboxSelector.Item = Item;

export default FileInboxSelector;
